import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    api: {
      host: 'api.ticketswitch.com',
      user: '',
      password: '',
      version: 'v1',
      callName: '',
      params: {},
      response: '',
      currency: null
    }
  },
  mutations: {
    setHost (state, host) {
      state.api.host = host
      // persist to localStorage
      localStorage.setItem('apiHost', host)
    },
    setUser (state, user) {
      state.api.user = user
      // persist to localStorage
      localStorage.setItem('apiUser', user)
    },
    setPassword (state, password) {
      state.api.password = password
      // persist to localStorage (base64 encode to obscure slightly)
      localStorage.setItem('apiPass', window.btoa(password))
    },
    setCallName (state, callName) {
      state.api.callName = callName
    },
    setParams (state, params) {
      state.api.params = params
    },
    setResponse (state, response) {
      state.api.response = response
    },
    setCurrency (state, currency) {
      state.api.currency = currency
    }
  },
  getters: {
    baseUrl: state => {
      return `https://${state.api.host}/f13/${state.api.callName}.${state.api.version}?user_id=${state.api.user}&user_passwd=${state.api.password}`
    },
    paramsAsQueryString: state => {
      let str = []
      for (var p in state.api.params) {
        if (state.api.params.hasOwnProperty(p)) {
          str.push(encodeURIComponent(p) + '=' + encodeURIComponent(state.api.params[p]))
        }
      }
      return str.join('&')
    },
    apiUrl: (state, getters) => {
      let url = getters.baseUrl
      if (getters.paramsAsQueryString) {
        url += '&' + getters.paramsAsQueryString
      }
      return url
    },
    apiConfigValid: state => {
      if (state.api.host && state.api.user && state.api.password) {
        return true
      }
      return false
    }
  },
  actions: {
    fetchApiConfigFromLocalStorage (context) {
      let apiHost = localStorage.getItem('apiHost')
      let apiUser = localStorage.getItem('apiUser')
      let apiPassEncoded = localStorage.getItem('apiPass')
      if (apiHost && apiUser && apiPassEncoded) {
        let apiPass = window.atob(apiPassEncoded)
        context.commit('setHost', apiHost)
        context.commit('setUser', apiUser)
        context.commit('setPassword', apiPass)
        return true
      }
      return false
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store.js